import { resolveUserBeatUrl } from '@/services/userbeat/dnsOverHTTP';
import { updateLocalStorage } from '@/services/userbeat/storage';
import { shouldSendMetric } from '@/services/userbeat/utils';
import { getEnvironment } from '@/utils';
import { fetchAuthSession } from 'aws-amplify/auth';

export async function sendUserMetric(metricName: string = 'manager-v1') {
  if (getEnvironment() === 'production') {
    return;
  }
  if (shouldSendMetric(metricName) === false) {
    return;
  }
  const { tokens } = await fetchAuthSession();
  const url = await resolveUserBeatUrl();
  if (!url || !tokens?.idToken) return;

  await fetch(`https://${url}/${metricName}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'text/plain',
    },
    body: tokens.idToken.toString(),
  });
  updateLocalStorage(metricName);
}
